// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import { sub } from 'date-fns/sub'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_HouseholdV1GetsafeAt = z.object({
  dogs: z
    .array(z.object({ id: z.string(), name: z.string().min(1), breed: z.string().min(1) }))
    .optional(),
  town: z.string().min(1).optional(),
  street: z.string().min(1).optional(),
  born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(
      z.coerce
        .date()
        .min(sub(new Date(), { years: 120 }))
        .max(sub(new Date(), { years: 18 }))
    )
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    }),
  house_no: z.string().min(1).optional(),
  zip_code: z.string().min(1),
  flood_area: z.enum(['none', 'hq_300', 'hq_100']).optional(),
  cohabitants: z
    .array(
      z.object({
        last_name: z.string().min(1).optional(),
        first_name: z.string().min(1).optional(),
        date_of_birth: z
          .union([z.number(), z.string(), z.date()])
          .pipe(z.coerce.date())
          .transform((value) => {
            return format(value, constants.SERVER_DATE_FORMAT)
          })
          .optional(),
      })
    )
    .optional(),
  tariff_line: z.enum(['comfort', 'premium']),
  business_use: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
  dog_coverage: z.boolean(),
  bike_coverage: z.boolean(),
  square_meters: z.preprocess((val) => {
    if (val === '' || val === undefined) {
      return undefined
    }
    return Number(val)
  }, z.number().int().gte(20).lte(220)),
  gadget_coverage: z.boolean(),
  bike_sum_insured: z.enum(['min_1500', 'min_2000', 'min_4000']).optional(),
  furnishing_level: z.enum(['simple', 'comfortable', 'upscale']),
  cohabitation_type: z.enum(['single', 'family', 'others']),
  deductible_amount: z.coerce
    .string()
    .pipe(z.enum(['0', '250', '500']))
    .pipe(z.coerce.number()),
  insured_sum_amount: z.preprocess((val) => {
    if (val === '' || val === undefined) {
      return undefined
    }
    return Number(val)
  }, z.number().int()),
  assistance_coverage: z.boolean(),
  constant_occupation: z.coerce
    .string()
    .pipe(z.enum(['true']))
    .transform(() => true)
    .optional(),
  number_of_previous_claims: z.coerce
    .string()
    .pipe(z.enum(['0', '1']))
    .pipe(z.coerce.number())
    .optional(),
  cancelled_by_previous_insurer: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
  natural_disasters_damage_in_last_10_years: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
})

const Schema_HouseholdV1GetsafeAt = BaseSchema_HouseholdV1GetsafeAt.superRefine((values, ctx) => {
  if (values['dog_coverage'] !== undefined && [true].includes(values['dog_coverage'])) {
    if (values['dogs'] === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_type,
        expected: 'array',
        received: 'undefined',
        message: 'Required',
        path: ['dogs'],
      })
    }
  }
})
  .superRefine((values, ctx) => {
    if (
      values['cohabitation_type'] !== undefined &&
      ['others'].includes(values['cohabitation_type'])
    ) {
      if (values['cohabitants'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'array',
          received: 'undefined',
          message: 'Required',
          path: ['cohabitants'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (values['bike_coverage'] !== undefined && [true].includes(values['bike_coverage'])) {
      if (values['bike_sum_insured'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'string',
          received: 'undefined',
          message: 'Required',
          path: ['bike_sum_insured'],
        })
      }
    }
  })

export default Schema_HouseholdV1GetsafeAt
